export default __webpack_public_path__ + "media/images/elephant_ui_disappointed-f9ad2762754757ea0aad69b8f1546acd.svg";